export function formatMoney(value) {
  const amount = Number(value) || 0;

  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatCompactNumber(value) {
  const amount = Number(value) || 0;

  return new Intl.NumberFormat("en-IN", {
    notation: "compact",
    maximumFractionDigits: amount < 1000 ? 0 : 1,
  }).format(amount);
}

export function formatDate(value) {
  if (!value) {
    return "—";
  }

  return new Intl.DateTimeFormat("en-IN", {
    dateStyle: "medium",
  }).format(new Date(value));
}

export function formatDateTime(value) {
  if (!value) {
    return "—";
  }

  return new Intl.DateTimeFormat("en-IN", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(value));
}

export function slugify(value) {
  return String(value || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function getInitials(value) {
  const parts = String(value || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2);

  if (!parts.length) {
    return "GK";
  }

  return parts.map((part) => part[0].toUpperCase()).join("");
}

export function createId(prefix = "item") {
  return `${prefix}-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
}
